
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    DevelopmentVersion: {
        position: 'fixed',
        top: '100%',
        left: 0,
        width: 140,
        height: 140,
        marginTop: -140,
        zIndex: 99999
    },
    img: {
        background: 'url(/client/www/theme/images/develop_en.png)',
        width: 140,
        height: 140,
        opacity: 0.9
    }
});

const DevelopmentVersion = () => {

    const developmentVersion = window.ENV?.REACT_APP_DEVELOPMENT_VERSION === 'true';

    return (
        developmentVersion && (
            <div className={classNames.DevelopmentVersion}>
                <div className={classNames.img} />
            </div>
        )
    )
}

export default DevelopmentVersion;
